import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X, Mail, Instagram, Phone } from 'lucide-react';
import { Button } from '@/components/ui/Button';

interface ContactCreatorModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
  instagram: string;
  phone: string;
}

export function ContactCreatorModal({ isOpen, onClose, email, instagram, phone }: ContactCreatorModalProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 backdrop-blur-sm" />
        <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-sm bg-earth-900 p-6 rounded-lg shadow-xl">
          <div className="flex justify-between items-center mb-4">
            <Dialog.Title className="text-xl font-display">Contact Creator</Dialog.Title>
            <Dialog.Close className="text-sand-400 hover:text-sand-300">
              <X className="h-5 w-5" />
            </Dialog.Close>
          </div>
          <div className="flex flex-col gap-3">
            <a href={`mailto:${email}`} className="w-full">
              <Button variant="secondary" className="w-full flex items-center justify-center gap-2">
                <Mail className="h-5 w-5" />
                Email
              </Button>
            </a>
            <a href={`https://instagram.com/${instagram}`} target="_blank" rel="noopener noreferrer" className="w-full">
              <Button variant="secondary" className="w-full flex items-center justify-center gap-2">
                <Instagram className="h-5 w-5" />
                Instagram
              </Button>
            </a>
            <a href={`tel:${phone}`} className="w-full">
              <Button variant="secondary" className="w-full flex items-center justify-center gap-2">
                <Phone className="h-5 w-5" />
                Phone
              </Button>
            </a>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
} 